import { useState } from "react";
import { NotebookPen } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const FIELDS = [
  ["audience", "Target audience", "e.g. New VAs in the US, 25–45, interested in freelancing"],
  ["ad_copy", "Ad copy", "Headline and text used in the ad"],
  ["observations", "Observations", "What worked, what didn't, changes made"],
];
const area = "w-full px-3 py-2 rounded-lg border border-[#D9DEE4] bg-white text-[14px] focus:outline-none focus:ring-2 focus:ring-[#334E68] min-h-[72px]";

export default function CampaignNotes({ link, token, onSaved }) {
  const [open, setOpen] = useState(false);
  const [notes, setNotes] = useState({ audience: "", ad_copy: "", observations: "", ...(link.notes || {}) });
  const [state, setState] = useState("");

  const save = async () => {
    setState("saving");
    const r = await fetch(`${API}/api/marketing/stats/links/${link.id}/notes`, {
      method: "PUT",
      headers: { Authorization: `Bearer ${token}`, "Content-Type": "application/json" },
      body: JSON.stringify(notes),
    }).catch(() => null);
    if (!r?.ok) return setState(r?.status === 401 ? "expired" : "failed");
    onSaved(await r.json());
    setState("saved");
  };

  const updated = link.notes_updated_at && new Date(link.notes_updated_at).toLocaleString(undefined, { dateStyle: "medium", timeStyle: "short" });
  return (
    <div className="w-full">
      <button type="button" onClick={() => setOpen(!open)} aria-expanded={open} data-testid={`saved-link-notes-toggle-${link.id}`}
        className="inline-flex items-center gap-1.5 text-[12px] font-semibold text-[#334E68] hover:underline">
        <NotebookPen size={13} /> {open ? "Hide notes" : link.notes_updated_at ? "Notes" : "Add notes"}
        {updated && <span className="font-normal text-[#5B6B7B]" data-testid={`saved-link-notes-updated-${link.id}`}>· Last updated {updated}</span>}
      </button>
      {open && (
        <div className="mt-3 grid grid-cols-1 md:grid-cols-3 gap-3" data-testid={`saved-link-notes-${link.id}`}>
          {FIELDS.map(([k, label, ph]) => (
            <label key={k} className="block">
              <span className="block text-[12px] font-semibold uppercase tracking-[0.08em] text-[#5B6B7B] mb-1">{label}</span>
              <textarea className={area} placeholder={ph} value={notes[k]} maxLength={k === "audience" ? 2000 : 4000}
                onChange={(e) => { setNotes({ ...notes, [k]: e.target.value }); setState(""); }} data-testid={`saved-link-notes-${k}-${link.id}`} />
            </label>
          ))}
          <div className="md:col-span-3 flex items-center gap-3">
            <button type="button" onClick={save} disabled={state === "saving"} data-testid={`saved-link-notes-save-${link.id}`}
              className="px-4 py-2 rounded-full bg-[#334E68] hover:bg-[#22384F] disabled:opacity-50 text-white text-[13px] font-semibold transition-colors">
              {state === "saving" ? "Saving…" : "Save notes"}
            </button>
            {state === "saved" && <span className="text-[13px] text-[#2E7D32]" role="status">Saved.</span>}
            {state === "failed" && <span className="text-[13px] text-[#B42318]" role="alert">Could not save. Please try again.</span>}
            {state === "expired" && <span className="text-[13px] text-[#B42318]" role="alert">Session expired. Lock and unlock the page.</span>}
          </div>
        </div>
      )}
    </div>
  );
}
